import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import PropTypes from 'prop-types';
import AddStrategyButton from './AddStrategyButton';

const AddStrategyButtonPicker = (props) => {
  const { resource } = props; // TODO: Should come from page content resource

  return pickFunction(resource, {
    [fr.relationships.strategySetup.name]: () => {
      return (
        <AddStrategyButton {...props} />
      );
    },
    [fr.relationships.default.name]: () => {
      return null;
    },
  });
};

AddStrategyButtonPicker.defaultProps = {
  className: '',
};

AddStrategyButtonPicker.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default AddStrategyButtonPicker;
